const onFailure = (error) => ({
  message: 'Categoria de cliente já cadastrada!',
  type: 'warning',
});

export default onFailure;
